import { useTranslation } from 'react-i18next';
import { useSystemDevice } from '../../../hooks/useSystemDevice';
import './HeaderText.scss';

function HeaderText() {
  const scope = 'HeaderText';
  const systemDevice = useSystemDevice();
  const { t } = useTranslation();

  const className = [scope, `${scope}--${systemDevice}`].join(' ');

  return (
    <div className={className}>
      <h1 className={scope + '-heading'}>{t('defender_experience')}</h1>
      <div className={scope + '-info'}>{t('defender_experience_info')}</div>
      <div className={scope + '-location'}>
        {t('defender_experience_location')}
      </div>
    </div>
  );
}

export default HeaderText;
